import { FC } from "react";
import { QESWidget, QESWidgetContent, QESWidgetHeader, QESWidgetTitle } from "@app/shared/widget";

const ExceptionOverlapWidget: FC = () => (
    <div data-testid="compliance-connect__exception-overlap-widget">
        <QESWidget className="w-100">
            <QESWidgetHeader>
                <QESWidgetTitle>Exception Overlap</QESWidgetTitle>
            </QESWidgetHeader>
            <QESWidgetContent>
            </QESWidgetContent>
        </QESWidget>
    </div>
);

export default ExceptionOverlapWidget;
